// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "rules-3TdLa";
var _4 = "rules__title-q-Hub";
var _5 = "rules__text-2_unP";
var _6 = "rules__footer-2rm21";
var _7 = "rules__button-2pp1T";
var _8 = "rules__label-1Xssl";
var _9 = "rules__checkbox-WTVI8";
var _a = "rules__checkbox_checked-1wuI0";
export { _1 as "__esModule", _2 as "mobile", _3 as "rules", _4 as "rules__title", _5 as "rules__text", _6 as "rules__footer", _7 as "rules__button", _8 as "rules__label", _9 as "rules__checkbox", _a as "rules__checkbox_checked" }
export default { "__esModule": _1, "mobile": _2, "rules": _3, "rules__title": _4, "rules__text": _5, "rules__footer": _6, "rules__button": _7, "rules__label": _8, "rules__checkbox": _9, "rules__checkbox_checked": _a }
